<template>
  <div>
    <Dialog
      :key="sortByFieldsDialogKey"
      :visible.sync="sortByFieldsDialog1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Sort by Fields"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="filter1">Fields</label>
          <Dropdown
            v-model="filter1"
            :options="fieldsToDisplay"
            optionLabel="fieldName"
            dataKey="id"
            placeholder="------"
            :showClear="true"
          />
          <small
            class="p-invalid"
            v-if="fieldsEntered1 && !(filter1 && filter1.id)"
            >This field is required.</small
          >
        </div>
        <div class="p-col-12 p-md-4 p-lg-4">
          <label for="filter2">Asc/Desc</label>
          <Dropdown
            v-model="filter2"
            :options="options"
            optionLabel="label"
            dataKey="id"
            placeholder="------"
            :showClear="true"
          />
          <small
            class="p-invalid"
            v-if="fieldsEntered1 && !(filter2 && filter2.id)"
            >This field is required.</small
          >
        </div>
        <div class="p-col-12 p-md-4 p-lg-4">
          <div style="padding-top: 21px;">
            <Button
              label="Add"
              icon="pi pi-plus"
              class="p-button-info p-ml-2 p-mt-1"
              @click="add()"
            />
          </div>
        </div>
      </div>

      <br />

      <DataTable
        :value="sortOrders"
        class="p-datatable-sm"
        dataKey="oppId"
        :rowHover="true"
      >
        <Column field="field" header="Field" headerStyle="width: 6em">
          <template #body="slotProps">
            {{
              slotProps.data.field && slotProps.data.field.fieldName
                ? slotProps.data.field.fieldName
                : ""
            }}
          </template>
        </Column>
        <Column field="order" header="Order" headerStyle="width: 6em">
          <template #body="slotProps">
            {{ slotProps.data.order }}
          </template>
        </Column>
        <Column field="remove" header="Remove" headerStyle="width: 2em">
          <template #body="slotProps">
            <Button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
              @click="removeCondition(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>

      <br />
      <br />
      <br />
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "SortByFields",
  props: {
    sortByFieldsDialog: {
      type: Boolean,
      required: true
    },
    dbViewFields: {
      type: Array,
      required: false
    },
    sortByFieldsClause: {
      type: String,
      required: false
    }
  },
  data: () => ({
    sortByFieldsDialogKey: 0,
    fieldsToDisplay: [],
    filter1: {},
    filter2: {},
    options: [
      { id: 1, value: "ASC", label: "Ascending" },
      { id: 2, value: "DESC", label: "Descending" }
    ],
    sortOrders: [],
    fieldsEntered1: false
  }),
  computed: {
    sortByFieldsDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.sortByFieldsDialog;
      }
    }
  },
  created() {
    //
    this.setupFieldsToBeDisplayed();
  },
  watch: {
    sortByFieldsDialog(val) {
      if (val) {
        this.sortByFieldsDialogKey++;
      }
      this.setupFieldsToBeDisplayed();
    }
  },
  methods: {
    createStringToShow() {
      var strToShow = "";

      this.sortOrders.forEach((filter, index) => {
        if (
          index !== 0 &&
          filter.field &&
          filter.field.dbField &&
          filter.order
        ) {
          strToShow = strToShow.concat(
            `, ${filter.field.fieldName} ${filter.order}`
          );
        } else if (
          index === 0 &&
          filter.field &&
          filter.field.dbField &&
          filter.order
        ) {
          strToShow = strToShow.concat(
            `${filter.field.fieldName} ${filter.order}`
          );
        }
        //
      });
      //
      this.$emit("strToShow", strToShow);
    },
    save() {
      var str = "",
        strToShow = "";
      //

      this.sortOrders.forEach((filter, index) => {
        if (
          index !== 0 &&
          filter.field &&
          filter.field.dbField &&
          filter.order
        ) {
          str = str.concat(`, ${filter.field.dbField} ${filter.order}`);
          strToShow = strToShow.concat(
            `, ${filter.field.fieldName} ${filter.order}`
          );
        } else if (
          index === 0 &&
          filter.field &&
          filter.field.dbField &&
          filter.order
        ) {
          str = str.concat(`${filter.field.dbField} ${filter.order}`);
          strToShow = strToShow.concat(
            `${filter.field.fieldName} ${filter.order}`
          );
        }
        //
      });

      if (str) {
        this.$emit("sortByFieldString", { str, strToShow });
      }
    },
    removeCondition(data) {
      let i = this.sortOrders.findIndex(filter => filter.id === data.id);
      this.sortOrders.splice(i, 1);
    },
    add() {
      this.fieldsEntered1 = true;

      if (this.filter1 && this.filter1.id && this.filter2 && this.filter2.id) {
        this.sortOrders.push({
          id: this.sortOrders.length + 1,
          field: this.filter1,
          order: this.filter2.value
        });
        let index = this.fieldsToDisplay.findIndex(
          a => a.id === this.filter1.id
        );
        this.fieldsToDisplay.splice(index, 1);

        this.filter1 = {};
        this.filter2 = {};
        this.fieldsEntered1 = false;
      }
    },
    getDifference(a, b) {
      var i = 0;
      var j = 0;
      var result = "";

      while (j < b.length) {
        if (a[i] != b[j] || i == a.length) result += b[j];
        else i++;
        j++;
      }
      return result;
    },
    setupFieldsToBeDisplayed() {
      this.fieldsToDisplay = this.dbViewFields.filter(a => a.canSort);
      // this.fieldsToDisplay = this.dbViewFields

      // Parser

      if (this.sortByFieldsClause) {
        var clauses = this.sortByFieldsClause.split(",");

        for (let i = 0; i < clauses.length; i++) {
          var clause = clauses[i];
          let field = {},
            order = "";

          if (i > 0) {
            clause = clause.substring(1, clause.length);
          }

          for (let j = 0; j < this.options.length; j++) {
            let a = clause.indexOf(` ${this.options[j].value}`);
            if (a > -1) {
              order = this.options[j].value;
              clause = clause.substring(
                0,
                clause.length - this.options[j].value.length - 1
              ); // 1 is to remove the space at end
            }
          }

          field = this.dbViewFields.find(b => {
            //
            //
            if (b.dbField === clause) return b;
          });

          if (
            !this.sortOrders.find(
              b =>
                b.field &&
                b.field.fieldName === field.fieldName &&
                b.order === order
            )
          )
            this.sortOrders.push({
              id: this.sortOrders.length + 1,
              field,
              order
            });
        }
      }

      //
      this.createStringToShow();
    }
  }
};
</script>

<style></style>
